import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {inject, observer} from 'mobx-react';
import moment from 'moment';

import {HeadingDesktop, HeadingMobile} from 'components/Heading';
import CloudinaryPicture from 'components/CloudinaryPicture';
import CloudinaryPictureWithControls from 'components/CloudinaryPictureWithControls';
import {TextDesktop, TextMobile} from 'components/Text';
import InfoModal from 'components/InfoModal';
import {FormattedMessage} from 'components/FormattedComponents';
import {DATE_TIME_FORMAT} from 'constants';

import messages from './messages';
import {ContentWrapper, InstructionCover, LastPublishedAt} from './styles';

@inject('store')
@observer
class InstructionCoverBase extends Component {
  componentDidMount = () => {
    const {
      store: {
        checklist,
        platform: {hasChecklistsEnabled}
      },
      isChecklist
    } = this.props;

    if (isChecklist && !hasChecklistsEnabled && checklist) {
      checklist.openChecklistsDisabledModal(true);
    }
  };

  render() {
    const {
      aspectRatio,
      device,
      imageSizes,
      guideTitle,
      imageUrl,
      instructionTitle,
      metadata = {},
      shouldShowSpinnerWhileLoading = false,
      store: {checklist},
      intl: {formatMessage},
      lastPublishedAt
    } = this.props;

    const isMobile = device === 'mobile';

    const Heading = isMobile ? HeadingMobile : HeadingDesktop;
    const Picture = isMobile ? CloudinaryPicture : CloudinaryPictureWithControls;
    const Text = isMobile ? TextMobile : TextDesktop;

    return (
      <InstructionCover data-cy="instruction-cover">
        <InfoModal
          isDesktop={!isMobile}
          isOpen={checklist && checklist.showChecklistsDisabledModal}
          onClose={checklist ? checklist.closeChecklistsDisabledModal : undefined}
          onRightButtonClick={checklist ? checklist.closeChecklistsDisabledModal : undefined}
          rightButtonText={formatMessage(messages.ok)}
          subtitle={formatMessage(messages.checklistsDisabledSubtitle)}
          additionalInfo={formatMessage(messages.checklistsContactAdmin)}
          title={formatMessage(messages.checklistsDisabled)}
        />
        <Picture
          aspectRatio={aspectRatio}
          metadata={metadata}
          shouldShowSpinnerWhileLoading={shouldShowSpinnerWhileLoading}
          shouldShowOverlayShapes
          src={imageUrl}
          sizes={imageSizes}
        />
        <ContentWrapper>
          <div>
            <Text secondary ellipsis>
              {guideTitle}
            </Text>
            <Heading size={'large'}>{instructionTitle}</Heading>
          </div>
          {lastPublishedAt && (
            <LastPublishedAt>
              <FormattedMessage {...messages.lastPublishAt} /> {moment(lastPublishedAt).format(DATE_TIME_FORMAT)}
            </LastPublishedAt>
          )}
        </ContentWrapper>
      </InstructionCover>
    );
  }
}

export default injectIntl(InstructionCoverBase);
